import React from "react";
import "./SkillSection.css";

const SkillSection = () => {
    return (
        <section className="skill-section">
            <div className="skill-container">

                {/* LEFT SIDE */}
                <div className="skill-visuals">
                    <div className="visual-grid">

                        {/* ROW 1 */}
                        <div className="grid-item">
                            <div className="image-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/Skill-1.jpg" alt="team" />
                            </div>
                        </div>

                        <div className="grid-item">
                            <div className="icon-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/icon.png" alt="figma" />
                                <span>Figma</span>
                            </div>
                        </div>

                        <div className="grid-item">
                            <div className="icon-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/icon-3.png" alt="xd" />
                                <span>Adobe XD</span>
                            </div>
                        </div>

                        {/* ROW 2 */}
                        <div className="grid-item">
                            <div className="icon-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/icon-1.png" alt="ps" />
                                <span>Photoshop</span>
                            </div>
                        </div>

                        <div className="grid-item ">
                            <div className="center-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/640px-Sketch_Logo-1.png" alt="sketch" />
                                <span className="highlight-label">Sketch</span>
                            </div>
                        </div>

                        <div className="grid-item">
                            <div className="image-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/Skill-2.jpg" alt="team" />
                            </div>
                        </div>

                        {/* ROW 3 */}
                        <div className="grid-item">
                            <div className="image-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/Skill-3.jpg" alt="team" />
                            </div>
                        </div>

                        <div className="grid-item">
                            <div className="icon-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/icon-2.png" alt="invision" />
                                <span>Invision</span>
                            </div>
                        </div>

                        <div className="grid-item">
                            <div className="icon-wrapper">
                                <img src="https://dev254.kodesolution.com/edigitaal/wp-content/uploads/2025/11/icon-4.png" alt="illustrator" />
                                <span>Illustrator</span>
                            </div>
                        </div>

                    </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="skill-content">
                    <span className="sub-title">✦ OUR SKILL</span>
                    <h2>
                        Innovating <br />
                        <span className="highlight-text">Through Expertise</span>
                    </h2>

                    <div className="skill-bars">

                        <div className="skill-card card-1">
                            <h3>SEO & Google Ranking</h3>
                        </div>

                        <div className="skill-card card-2">
                            <h3>Website & App Development</h3>
                        </div>

                        <div className="skill-card card-3">
                            <h3>Custom Software (CRM / ERP)</h3>
                        </div>

                        <div className="skill-card card-4">
                            <h3>E-Commerce & Social Media Management</h3>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default SkillSection;